var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSousCatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.234,
    height: 37.2,
    viewBox: "0 0 40.234 37.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_113",
    x: 0,
    y: 0,
    width: 20.041,
    height: 23.541,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_120",
    x: 15.191,
    y: 4.157,
    width: 25.041,
    height: 15.181,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_121",
    x: 15.189,
    y: 18.185,
    width: 25.045,
    height: 15.184,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_122",
    x: 0,
    y: 13.659,
    width: 20.041,
    height: 23.541,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_123",
    x: 2.639,
    y: 16.298,
    width: 14.763,
    height: 18.263,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_95",
    "data-name": "Groupe 95",
    transform: "translate(-134.142 -442.249)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 134.14, 442.25)",
    filter: "url(#Trac\\xE9_113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_113-2",
    "data-name": "Trac\\xE9 113",
    d: "M294.886,595.166c0-.944,0-1.887,0-2.831a2.637,2.637,0,0,1,2.709-2.7q2.782,0,5.564,0a2.641,2.641,0,0,1,2.767,2.775q0,2.732,0,5.465a2.645,2.645,0,0,1-2.808,2.8h-5.432a2.644,2.644,0,0,1-2.8-2.809Q294.886,596.516,294.886,595.166Zm10.011-.012c0-.955,0-1.909,0-2.864a1.575,1.575,0,0,0-1.617-1.625q-2.864-.007-5.728,0a1.577,1.577,0,0,0-1.634,1.642q0,2.848,0,5.7a1.578,1.578,0,0,0,1.634,1.643q2.848.006,5.7,0a1.582,1.582,0,0,0,1.652-1.659C304.9,597.042,304.9,596.1,304.9,595.155Z",
    transform: "translate(-290.39 -589.63)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_99",
    "data-name": "Groupe 99",
    transform: "translate(153.831 446.406)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.69, -4.16)",
    filter: "url(#Trac\\xE9_120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_120-2",
    "data-name": "Trac\\xE9 120",
    d: "M1071.021,416.868c-2.2,0-4.406,0-6.61,0a1.325,1.325,0,0,1-1.344-1.655,1.263,1.263,0,0,1,.993-.976,2.152,2.152,0,0,1,.5-.045q6.485,0,12.969,0a2.158,2.158,0,0,1,.647.084,1.314,1.314,0,0,1,.876,1.484,1.331,1.331,0,0,1-1.325,1.106c-1.452.007-2.9,0-4.354,0Z",
    transform: "translate(-1043.33 -410.03)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.69, -4.16)",
    filter: "url(#Trac\\xE9_121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_121-2",
    "data-name": "Trac\\xE9 121",
    d: "M1071.044,542.228q3.321,0,6.641,0a1.32,1.32,0,0,1,1.291.908,1.34,1.34,0,0,1-.424,1.469,1.555,1.555,0,0,1-1.028.3q-5.388,0-10.776,0c-.783,0-1.566.007-2.349,0a1.354,1.354,0,0,1-1.345-.972,1.337,1.337,0,0,1,1.256-1.7c.25-.008.5,0,.752,0Z",
    transform: "translate(-1043.31 -524.04)",
    fill: "#f99b29"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 134.14, 442.25)",
    filter: "url(#Trac\\xE9_122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_122-2",
    "data-name": "Trac\\xE9 122",
    d: "M294.886,595.166c0-.944,0-1.887,0-2.831a2.637,2.637,0,0,1,2.709-2.7q2.782,0,5.564,0a2.641,2.641,0,0,1,2.767,2.775q0,2.732,0,5.465a2.645,2.645,0,0,1-2.808,2.8h-5.432a2.644,2.644,0,0,1-2.8-2.809Q294.886,596.516,294.886,595.166Zm10.011-.012c0-.955,0-1.909,0-2.864a1.575,1.575,0,0,0-1.617-1.625q-2.864-.007-5.728,0a1.577,1.577,0,0,0-1.634,1.642q0,2.848,0,5.7a1.578,1.578,0,0,0,1.634,1.643q2.848.006,5.7,0a1.582,1.582,0,0,0,1.652-1.659C304.9,597.042,304.9,596.1,304.9,595.155Z",
    transform: "translate(-290.39 -575.97)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 134.14, 442.25)",
    filter: "url(#Trac\\xE9_123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_123-2",
    "data-name": "Trac\\xE9 123",
    d: "M327.305,623.081c-.616,0-1.174,0-1.733,0-.39,0-.635-.205-.634-.514s.244-.51.636-.513c.558,0,1.117,0,1.732,0v-.82c0-.274,0-.548,0-.822,0-.475.187-.732.522-.726s.506.26.506.742c0,.525,0,1.05,0,1.625h1.386c.143,0,.285-.005.427,0a.53.53,0,0,1,.553.5.524.524,0,0,1-.553.528c-.5.011-1.008,0-1.513,0-.086,0-.172.008-.3.014v1.084c0,.186,0,.373,0,.559,0,.452-.182.7-.507.709s-.52-.249-.522-.694,0-.877,0-1.315Z",
    transform: "translate(-317.8 -603.39)",
    fill: "#f99b29"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSousCatIcon);
export default __webpack_public_path__ + "static/media/sous-cat-icon.d805c6687a972dd52993912169b8a814.svg";
export { ForwardRef as ReactComponent };